import { ButtonPrimary } from '@steelbuy/ui-primitive';
import './CreateListingPortalCard.scss';

type CreateListingPortalCardProps = {
    heading: string;
    description: string;
    buttonLabel: string;
    buttonOnClick: () => void;
};

export const CreateListingPortalCard = ({
    heading,
    description,
    buttonLabel,
    buttonOnClick,
}: CreateListingPortalCardProps) => (
    <div className="create-listing-portal-card-container">
        <div>
            <div className="create-listing-portal-card-container__header">{heading}</div>
            <div className="create-listing-portal-card-container__description">{description}</div>
        </div>
        <div className="create-listing-portal-card-container__children">
            <ButtonPrimary label={buttonLabel} onClick={buttonOnClick} />
        </div>
    </div>
);
